import { ISRProps } from './ISR.types';
// import './ISRReportModalContent.scss';
import styles from './ISRReportModalContent.module.scss';
const okColor = getComputedStyle(document.documentElement).getPropertyValue('--border-success-default').trim();
const badColor = getComputedStyle(document.documentElement).getPropertyValue('--border-error-default').trim();
function isBadISR(isr: string) {
  return (
    /≥\s*50/.test(isr) ||
    />=\s*50/.test(isr) ||
    /50\%?\s*or\s*higher/i.test(isr)
  );
}

export default function ISRReportModalContent({ data }: ISRProps) {
  const total = data.length;
  const badCount = data.filter((d) => isBadISR(d.isr)).length;

  return (
    <div className={styles['summary-container']}>
      {/* <div className={styles["header"]}>
        <div className={styles["top"]}>
          <div className={styles["title"]}>In-Stent Restenosis Report</div>
          <Close className={styles["icon"]} onClick={onClose} />
        </div>
        <div className={styles["divider"]} />
      </div> */}
      <div className={styles['vessel-summary-container']}>
        {total === 0 ? (
          <div className={styles['vessel-summary-row2']}>
            <div className={styles['container2']}>
              <div className={styles['footer-toggle2']}>
                <span>
                  No data available to generate the report.
                  <br />
                  Please enter the required analysis data and try again.
                </span>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className={styles['vessel-summary-container2']}>
              <div className={styles['container0']}>
                <div className={styles['vessel-summary-row']}>
                  <div className={styles['container']}>
                    <span className={styles['footer-toggle']}>
                      {`Summary:`}
                    </span>
                  </div>
                  <span className={styles['total-top-up']}>
                    {`Total vessels with stents: ${total} | ISR ≥ 50% detected: ${badCount}/${total} vessels`}
                  </span>
                </div>
              </div>
              <div className={styles['vessel-detail-container']}>
                <div className={styles['vessel-detail-container']}>
                  <div className={styles['footer-toggle']}>
                    <div className={styles['line99']} />
                    <div className={styles['container']}>
                      {data.map((d, idx) => {
                        const bad = isBadISR(d.isr);
                        return (
                          <div
                            className={styles['vessel-detail-row']}
                            key={`${d.branch}-${idx}`}
                          >
                            <div className={styles['container']}>
                              <span className={styles['footer-toggle']}>
                                {`${d.branch}:`}
                              </span>
                            </div>
                            <div
                              className={styles['vessel-detail-text-container']}
                            >
                              <span className={styles['total-top-up']}>
                                {`Stent ${idx + 1}: ${d.lengthMm}mm`}
                              </span>
                              <div className={styles['container']}>
                                <span
                                  className={`${styles['footer-toggle']} ${styles[bad ? 'bad' : 'ok']}`}
                                >
                                  {`ISR ${d.isr}`}
                                </span>
                              </div>
                            </div>
                          </div>
                          // <div className={styles["row"]} key={`${d.branch}-${idx}`}>
                          //   <span className={styles["branch"]}>{d.branch}:</span>
                          //   <span className={styles["desc"]}>
                          //     Stent {idx + 1}: {d.lengthMm}mm,
                          //   </span>
                          //   <span className={`isr ${bad ? 'bad' : 'ok'}`}>
                          //     ISR {d.isr}
                          //   </span>
                          // </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className={styles['main-container']}>
          <div className={styles['content-container']}>
            {data.map((d, idx) => {
              const bad = isBadISR(d.isr);
              return (
                <div className={styles['content-row']} key={idx}>
                  <div className={styles['image-container']}>
                    <div className={styles['footer-toggle']}>
                      <div className={styles['line99']} />
                      {d.branch}
                    </div>
                    <div className={styles['vessel-images']}>
                      <div
                        className={`${styles['content-block']} ${styles[bad ? 'bad' : 'ok']}`}
                      >
                        <img
                          className={styles['full']}
                          src={d.images?.fullCpr}
                          alt={`${d.branch} Full CPR`}
                          // style={{borderColor:bad?badColor:okColor}}
                        />
                        <div className={styles['chip']}>
                          <span className={styles['button']}>
                            {`Full CPR`}{' '}
                          </span>
                        </div>
                      </div>

                      <div
                        className={`${styles['content-block']} ${styles[bad ? 'bad' : 'ok']}`}
                      >
                        <img
                          className={styles['stent']}
                          src={d.images?.stent}
                          alt={`${d.branch} Stent`}
                          // style={{borderColor:bad?badColor:okColor}}
                        />
                        <div className={styles['chip']}>
                          <span className={styles['button']}>{`Stent`} </span>
                        </div>
                      </div>
                    </div>

                    {/* <div className={`card ${bad ? 'danger' : 'safe'}`}>
                      <span className={styles["tag"]}>Full CPR</span>
                      <div className={styles["imageBox"]}>
                        {d.images?.fullCpr ? (
                          <img
                            src={d.images.fullCpr}
                            alt={`${d.branch} Full CPR`}
                          />
                        ) : null}
                      </div>
                    </div>

                    <div className={`card ${bad ? 'danger' : 'safe'}`}>
                      <span className={styles["tag"]}>Stent</span>
                      <div className={styles["imageBox"]}>
                        {d.images?.stent ? (
                          <div
                            style={{
                              width: '100%',
                              height: '100%',
                              backgroundColor: '#0D0D0D',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundImage: `url(${d.images.stent})`,
                              backgroundSize: 'contain',
                              backgroundPosition: 'center',
                              backgroundRepeat: 'no-repeat',
                              flex : '1'
                            }}
                          />
                        ) : null}
                      </div>
                    </div> */}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
